import { updateEmployeeType } from "../../../../../actions/Utilities/EmployeeType";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useUpdateEmployeeType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (employeeTypeNewData) => updateEmployeeType(employeeTypeNewData),
    {
      onSuccess: (res) => {
        if (res == "Duplicate") {
          toast.fire("Saving Failed", "Employee Type already exists!", "error");
        } else {
          queryClient.invalidateQueries(["GetEmployeeType"]);
          toast.fire(
            "Success",
            "Updated Employee Type Successfully",
            "success"
          );
        }
      },
      onError: () => {
        toast.fire("Failed", "Failed to Update Employee Type", "error");
      },
    }
  );
  return mutate;
};
export default useUpdateEmployeeType;
